import AppConstants from '../constants/AppConstants';
import {
  CompanyDocumentRes,
  CompanyDocumentResPage,
  CompanyDocumentType,
  FileParameter,
  JobsiteReq,
  JobsiteRes
} from '../proxy/proxy';
import {
  AxiosCompanyDocumentsClient,
  AxiosJobsitesClient
} from '../proxy/ProxyClients';

const CompanyDocumentsService = {
  getAllCompanyDocuments: (): Promise<Array<CompanyDocumentRes>> =>
    AxiosCompanyDocumentsClient.page({
      pageNumber: 1,
      pageSize: AppConstants.MAX_PAGE_SIZE
    }).then((resp) => resp?.items || []),

  getCompanyDocumentById: (id: number) => AxiosCompanyDocumentsClient.get(id)
    .then((resp) => resp),

  createCompanyDocument: (
    title: string | undefined,
    description: string | undefined,
    companyDocumentType: CompanyDocumentType | undefined,
    file: FileParameter | undefined
  ) =>
    AxiosCompanyDocumentsClient.create(
      title,
      description,
      companyDocumentType,
      file
    ),

  updateCompanyDocument: (
    documentId: number | undefined,
    title: string | undefined,
    description: string | undefined,
    companyDocumentType: CompanyDocumentType | undefined,
    file: FileParameter | undefined
  ) =>
    AxiosCompanyDocumentsClient.update(
      documentId,
      title,
      description,
      companyDocumentType,
      file
    )

  //   deleteStore: (id: number = 0) => AxiosJobsitesClient.softDelete(id)
};

export default CompanyDocumentsService;
